import { useEffect } from 'react';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
  useTechDocsReaderPage,
} from '@backstage/plugin-techdocs-react';
import { guestTechDocsAddonsPlugin } from './guestTechDocsAddonsPlugin';
import { useIsLegacyWikiDocs } from '../wiki/useIsLegacyWikiDocs';

const STYLE_ID = 'wiki-content-styles';

const paperclip = encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"/></svg>',
);

const css = `
.md-typeset__scrollwrap,
.md-typeset__table {
  display: block !important;
  width: 100%;
}
.md-typeset table:not([class]) {
  display: table !important;
  width: 100%;
}
.md-typeset a[href*="attachments/"]::after {
  content: '';
  display: inline-block;
  width: 1em;
  height: 1em;
  margin-left: 0.15em;
  vertical-align: -0.15em;
  background-color: currentColor;
  -webkit-mask: url("data:image/svg+xml,${paperclip}") center / contain no-repeat;
  mask: url("data:image/svg+xml,${paperclip}") center / contain no-repeat;
}
`;

const WikiContentStylesAddon = () => {
  const { shadowRoot } = useTechDocsReaderPage();
  const isWiki = useIsLegacyWikiDocs();

  useEffect(() => {
    if (!isWiki || !shadowRoot || shadowRoot.getElementById(STYLE_ID)) {
      return;
    }
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    shadowRoot.appendChild(style);
  }, [isWiki, shadowRoot]);

  return null;
};

export const WikiContentStyles = guestTechDocsAddonsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'WikiContentStyles',
    location: TechDocsAddonLocations.Content,
    component: WikiContentStylesAddon,
  }),
);
